<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.3949 9.55047C17.5747 9.32195 17.5518 8.99441 17.3416 8.79332C17.1329 8.59223 16.8053 8.58156 16.5829 8.77047L6.44292 17.3977L1.08822 15.3258C0.612884 15.1445 0.286883 14.7012 0.254903 14.1924C0.221388 13.6851 0.48799 13.2036 0.937403 12.963L23.1674 0.510271C23.5224 0.318317 23.955 0.338121 24.2917 0.560546C24.6299 0.784492 24.8158 1.17601 24.7777 1.57821L22.8277 21.9054C22.7881 22.3274 22.5504 22.7067 22.1894 22.9276C21.8268 23.1485 21.3804 23.1866 20.9874 23.0282L14.4701 20.5053L10.3782 24.3383C10.0705 24.6262 9.61954 24.7039 9.23259 24.5348C8.84563 24.3642 8.59732 23.9803 8.60036 23.5583V20.548L17.3949 9.55047Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Send',
};
</script>
